import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FormsModule } from '@angular/forms';
import { InterceptorService } from '@core/services/interceptor.service';
import { ModalService } from '@core/services/modal.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { environment as env } from "../environments/environment";
import { GlobalErrorHandlerService } from '@core/services/global-error-handler.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';

// Función para cargar archivos de traducción
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

registerLocaleData(en);

// Un truco sencillo para detectar dispositivos antiguos de Apple
const isOldIOS = /iP(ad|hone|od).+OS 1[0-5]_\d/.test(navigator.userAgent);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        },
        defaultLanguage: 'es'
      })
    ),
    // Si es un iOS 15 o menor, apagamos las animaciones para salvar memoria.
    // Si es un dispositivo moderno, las cargamos de forma perezosa (Async).
    isOldIOS ? provideNoopAnimations() : provideAnimationsAsync(),
    ModalService,
    NzModalService,
    provideEnvironmentNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: ErrorHandler, useClass: GlobalErrorHandlerService
    }
  ]

};
